import { useDialog } from 'muibox';
import { useContext } from 'react';
import { useQuery } from 'react-query';
import { SettingsContext } from '../store/SettingsContext';
import { UserContext } from '../store/UserContext';
import { handleHttpError } from '../utils/common';
import useAxios from './useAxios';

export interface SextforceTransactionsHourlySalesData {
    date: string;
    hour: number;
    dayOfWeek: number;
    totalAmount?: number;
    totalTransactions?: number;
    uniqueFans: number;
    avgAmountPerFan?: number;
    avgAmountPerTransaction?: number;
    fans?: {
        userId: number;
        username: string;
        amount: number;
        transactions: number;
    }[];
}

const useSextforceTransactionsHourlySalesData = (subscriberId: string | undefined | null, dateFrom: Date | null, dateTo: Date | null) => {
    const userContext = useContext(UserContext);
    const settingsContext = useContext(SettingsContext);
    const dialog = useDialog();
    const axios = useAxios();

    // Fetch Report
    const fetchTransactions = async (): Promise<SextforceTransactionsHourlySalesData[]> => {
        if (!userContext.jwtToken || !settingsContext.apiKey || !subscriberId || !dateFrom || !dateTo) {
            return [];
        }

        const query: string = `${settingsContext.routes.transactions.base}${subscriberId}/hourlySales?${new URLSearchParams({
            dateFrom: dateFrom.toISOString(),
            dateTo: dateTo.toISOString(),
        })}`;

        const data = await axios
            .get(query)
            .then(async response => response.data)
            .catch(error => {
                console.error(error);
                handleHttpError(error, dialog);

                return [];
            });

        return data;
    };

    const query = useQuery(['transactionsHourlySales', subscriberId, dateFrom, dateTo], () => fetchTransactions(), {
        refetchOnWindowFocus: false,
        staleTime: 0,
        enabled: userContext.jwtToken && settingsContext.apiKey && subscriberId && dateFrom && dateTo ? true : false,
    });

    return { ...query };
};

export default useSextforceTransactionsHourlySalesData;
